//@flow
import React from 'react';
import PropTypes from 'prop-types';
import {isIphone13} from '../../../../../utils/string';

import style from './IphoneQempoFullWarning.scss';
import icons from '../../../../../assets/styles/icons.scss';

type Props = {
  items: {
    name: string; 
    url: string;
  }[];
};

export default function IphoneQempoFullWarning(props: Props) {
  const {items} = props;
  
  const hasIphone13 = items.some((i) => isIphone13(i.url, i.name));
  
  const message = (
    <p className={style.messageText}>
      <i className={icons.symbolExclamationCircle}/>
      <span>
        Todos los pedidos de iPhone 13 solo serán aplicables por Qempo Lite. Los iPhone 13 por Qempo Full serán cancelados.
        <a target="_blank" href="https://wa.me/5117064549">Más información aquí.</a>
      </span>
    </p>
  );
  
  return (
    hasIphone13 && message
  );
}

IphoneQempoFullWarning.propTypes = {
  items: PropTypes.array.isRequired,
};



// WEBPACK FOOTER //
// ./src/modules/new-order/ProductStep/components/IphoneQempoFullWarning/IphoneQempoFullWarning.jsx